<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết thông tin giao hàng</h1>
      <div class="float-right d-flex">
        <div v-if="canChangeShippingStatus">
          <button
            class="f12 font-medium btn btn-outline-danger mr-2"
            @click="handleTrigger('CHANGE', false)"
          >
            Giao thất bại
          </button>
          <button
            class="f12 font-medium btn btn-outline-success mr-2"
            @click="handleTrigger('CHANGE')"
          >
            Giao thành công
          </button>
        </div>
        <div v-if="canTriggerShippingApproved">
          <button
            class="f12 font-medium btn btn-outline-warning mr-2"
            @click="handleUpdateShippingInfor"
          >
            Cập nhật
          </button>
          <button
            class="f12 font-medium btn btn-outline-success mr-2"
            @click="handleTrigger('APPROVED')"
          >
            Duyệt
          </button>
        </div>
        <button
          class="f12 font-medium btn btn-outline-secondary"
          @click="$router.push('/management-shipping')"
        >
          Quay lại
        </button>
      </div>
    </div>

    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 form-row">
        <div class="col-12">
          <div class="form-row gap-4">
            <div class="col-lg-6 col-md-12">
              <CardDetail title="Thông tin chung" :fields="generalFields">
                <template #shippingStatus="data">
                  <b-badge :variant="mapVariantShippingStatus[data.item.value]">
                    {{ mapTextShippingStatus[data.item.value] }}
                  </b-badge>
                </template>
                <template #approvedStatus="data">
                  <b-badge :variant="mapVariantApprovedStatus[data.item.value]">
                    {{ mapTextApprovedStatus[data.item.value] }}
                  </b-badge>
                </template>
                <template #deliveryDate="data">
                  {{ data.value | formatDate('HH:mm DD/MM/YYYY') }}
                </template>
                <template #fee="data">
                  {{ data.value | fomatCurrency }}
                </template>
              </CardDetail>
              <CardDetail
                type="table"
                :title="'Danh sách thiết bị'"
                :headers="[
                  { text: 'Loại thiết bị', key: 'deviceName' },
                  { text: 'Serial thiết bị gửi MC', key: 'serial' },
                ]"
                :fields="devices"
              />
              <CardDetail
                type="table"
                title="Lịch sử thay đổi"
                :headers="[
                  { text: 'Thời gian', key: 'createdAt', thStyle: { minWidth: '120px' } },
                  {
                    text: 'Người thực hiện',
                    key: 'createdByName',
                  },
                  { text: 'Loại hành động', key: 'action' },
                  { text: 'Lý do', key: 'note' },
                ]"
                :fields="actionHistories"
              >
                <template #createdAt="data">
                  {{ data.value | formatDate('HH:mm DD/MM/YYYY') }}
                </template>
              </CardDetail>
            </div>
            <div class="col-lg-6 col-md-12">
              <CardDetail type="images" title="Ảnh xác nhận giao hàng" :fields="imageUrls" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalUpdateShipping ref="modalUpdateShippingRef" @change="fetchData" />
    <PopupUpdateImgShipping ref="modalUpdateImgShippingRef" />
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import CardDetail from '@/components/CardDetail.vue'
  import { mapGetters } from 'vuex'
  import { LeadsService } from '@/services/lead.service'
  import Config from '@/thirdParty/config'
  import { showMessSuccess, showMessError, showMessErrorResponse } from '@/config/utils'
  import ModalUpdateShipping from '@/components/Merchant/ModalUpdateShipping.vue'
  import PopupUpdateImgShipping from './components/PopupUpdateImgShipping.vue'

  export default {
    name: 'DetailShippingInfor',

    components: {
      CardDetail,
      ModalUpdateShipping,
      PopupUpdateImgShipping,
    },

    data() {
      return {
        Config,
        leadId: '',
        shippingId: '',
        agentId: '',
        dataOverviewInfor: {},
        imageUrls: [],
        devices: [],
        actionHistories: [],
        showLoading: false,
        dataShipping: null,
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      canChangeShippingStatus() {
        return (
          this.dataPermission.includes('CNPS_LEAD_CHANGE_SHIPPING_STATUS') &&
          !['DELIVERED', 'FAILED'].includes(this.dataOverviewInfor.shippingStatus)
        )
      },
      canTriggerShippingApproved() {
        return (
          this.dataPermission.includes('CNPS_LEAD_SHIPPING_APPROVED') &&
          !['APPROVED', 'REJECTED'].includes(this.dataOverviewInfor.approvedStatus)
        )
      },
      mapTextShippingStatus() {
        return Config.ShippingStatus.reduce((acc, item) => {
          acc[item.id] = item.text
          return acc
        }, {})
      },
      mapTextCarrierName() {
        return Config.listCarrierName.reduce((acc, item) => {
          acc[item.id] = item.text
          return acc
        }, {})
      },
      mapVariantShippingStatus() {
        return Config.ShippingStatus.reduce((acc, item) => {
          acc[item.id] = item.variant
          return acc
        }, {})
      },
      mapTextApprovedStatus() {
        return Config.ShippingApprovedSatus.reduce((acc, item) => {
          acc[item.id] = item.text
          return acc
        }, {})
      },
      mapVariantApprovedStatus() {
        return Config.ShippingApprovedSatus.reduce((acc, item) => {
          acc[item.id] = item.variant
          return acc
        }, {})
      },
      generalFields() {
        const mapFields = {
          telesale: [{ label: 'Ghi chú', value: this.dataOverviewInfor.note }],
          lead: [
            {
              label: 'Ngày giao hàng',
              value: this.dataOverviewInfor.deliveryDate || '',
              key: 'deliveryDate',
            },
            {
              label: 'Trạng thái duyệt',
              value: this.dataOverviewInfor.approvedStatus || 'PENDING',
              key: 'approvedStatus',
            },
          ],
        }
        const type = this.dataPermission.includes('CNPS_LEAD_SHIPPING_APPROVED')
          ? 'lead'
          : 'telesale'
        let fields = [
          { label: 'Tên Merchant ĐKKD', value: this.dataOverviewInfor.merchantName || '' },
          { label: 'SĐT liên hệ', value: this.dataOverviewInfor.mobile || '' },
          { label: 'Tỉnh/Thành phố', value: this.dataOverviewInfor.city || '' },
          { label: 'Quận/Huyện', value: this.dataOverviewInfor.district || '' },
          { label: 'Phường/Xã', value: this.dataOverviewInfor.ward || '' },
          { label: 'Địa chỉ', value: this.dataOverviewInfor.address || '' },
          {
            label: 'Hình thức bàn giao',
            value: this.dataOverviewInfor.feeType === 'ONLINE' ? 'Online' : 'Offline',
          },
          {
            label: 'Đơn vị vận chuyển',
            value: this.mapTextCarrierName[this.dataOverviewInfor.carrierName] || '',
          },
          { label: 'Mã vận đơn', value: this.dataOverviewInfor.trackingCode || '' },
          { label: 'Giá vận chuyển', value: this.dataOverviewInfor.fee || '', key: 'fee' },
          {
            label: 'Trạng thái giao hàng',
            value: this.dataOverviewInfor.shippingStatus || '',
            key: 'shippingStatus',
          },
        ]
        fields = [...fields, ...mapFields[type]]
        return fields
      },
    },
    async created() {
      this.leadId = this.$route.params.leadId
    },
    async mounted() {
      await this.fetchData()
    },
    methods: {
      async handleTrigger(type, status = true) {
        const mapping = {
          CHANGE: {
            fields: 'shippingStatus',
            value: status ? 'DELIVERED' : 'FAILED',
            api: LeadsService.updateStatusShipping,
            name: `Đã chuyển trạng thái ${status ? 'giao hàng thành công' : 'giao hàng thất bại'}`,
          },
          APPROVED: {
            fields: 'approvedStatus',
            value: status ? 'APPROVED' : 'REJECTED',
            api: LeadsService.setApprovedShipping,
            name: `Đã ${status ? 'phê duyệt' : 'từ chối phê duyệt'}`,
          },
        }
        const typeMapping = mapping[type]
        if (!typeMapping) return
        let reason = null
        if (typeMapping.value === 'FAILED') {
          const { value: flag, note: inputNote } = await this.rejectMx('Lý do giao hàng thất bại')
          if (!flag) return
          if (!inputNote) {
            this.showFailMx('Vui lòng nhập lý do giao hàng thất bại')
            return
          }
          reason = inputNote
        }
        if (typeMapping.value === 'DELIVERED' && this.imageUrls.length === 0) {
          const updated = await this.$refs.modalUpdateImgShippingRef.openModal(
            this.leadId,
            this.shippingId
          )
          if (!updated) return
        }

        const params = {
          [typeMapping.fields]: typeMapping.value,
          leadShippingId: this.shippingId,
          leadId: this.leadId,
          ...(reason ? { reason } : {}),
        }
        const func = typeMapping.api
        try {
          this.showLoading = true
          const res = await func.bind(LeadsService)(params)
          if (res.code === 1000) {
            showMessSuccess(this, typeMapping.name)
            await this.fetchData()
          } else {
            this.showFailMx(res.message)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      handleUpdateShippingInfor() {
        this.$refs.modalUpdateShippingRef.setDataForm(this.dataShipping)
        this.$refs.modalUpdateShippingRef.openModal()
      },
      mapOverviewInfor(data) {
        return {
          merchantName: data.merchantName,
          mobile: data.mobile,
          city: data.city,
          district: data.district,
          ward: data.ward,
          address: data.address,
          feeType: data.feeType,
          carrierName: data.carrierName,
          trackingCode: data.trackingCode,
          deliveryDate: data.deliveryDate,
          fee: data.fee,
          shippingStatus: data.shippingStatus,
          approvedStatus: data.approvedStatus,
          note: data.note,
        }
      },
      async fetchData() {
        try {
          this.showLoading = true
          const response = await LeadsService.getDetailShippingInfor({ leadId: this.leadId })
          if (response.code === 1000) {
            this.dataShipping = response.data
            this.shippingId = response.data.id
            this.agentId = response.data.agentId
            const { devices = [], actionHistories = [], imageUrls = [], ...data } = response.data
            this.dataOverviewInfor = this.mapOverviewInfor(data)
            this.devices = devices
            this.actionHistories = actionHistories
            this.imageUrls = imageUrls
          } else {
            showMessError(this, response.message, 3000)
          }
        } catch (error) {
          showMessErrorResponse(this, error, 3000)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>
